import Model, { attr } from "@ember-data/model";

export default class HealthCentreLoincPreferredUnit extends Model {
  @attr("string") declare loincId: string;
  @attr("string") declare preferredUnit: string;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "health-centre-loinc-preferred-unit": HealthCentreLoincPreferredUnit;
  }
}
